// extracted by mini-css-extract-plugin
module.exports = {"HeadContainer":"History_HeadContainer__1vEht","TableContainer":"History_TableContainer__1t9PH"};